var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"info-container",class:{ 'info-container--error': _vm.error }},[(_vm.error)?_c('FontAwesomeIcon',{staticClass:"info-container__icon--error mr-1",attrs:{"icon":['far', 'exclamation-triangle']}}):_c('FontAwesomeIcon',{staticClass:"mr-1",attrs:{"icon":['far', 'info-circle']}}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }